import { Component, OnInit } from '@angular/core';
import { ParamMap } from '@angular/router';
import { CustomizationStoreService } from 'src/services/customization.store.service';

@Component({
  selector: 'vex-support-number',
  templateUrl: './support-number.component.html',
  styleUrls: ['./support-number.component.scss']
})
export class SupportNumberComponent {
  loading = true;
  terms_and_conditions;
  funderStyles;
  funderConfig;

  constructor(private customizationStoreService: CustomizationStoreService) {
    // set Customization data when CustomizationService request is completed
    
    this.customizationStoreService.getFunderStyles().subscribe(
      (styles) => {
        if (Object.keys(styles).length > 0) {
          this.funderStyles = styles;
        }
      },
    );

    this.customizationStoreService.getFunderConfig().subscribe(
      (config) => {
        if (Object.keys(config).length > 0) {
          this.funderConfig = config;
          this.setCustomization(this.funderConfig);
        }
      },
    );
  }

  setCustomization(config) {
    this.loading = true;
    this.terms_and_conditions = config.texts_terms_and_conditions;
    this.loading = false;
  }
}
